const marquee = (els, innerSelector, childSelector, options = {}) => {
  const { pxPerSec = 80, tripleAfterFill = true } = options;

  const waitImages = (root) => {
    const imgs = Array.from(root.querySelectorAll("img"));
    if (!imgs.length) return Promise.resolve();

    return Promise.all(
      imgs.map((img) => {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();

        if (img.decode) {
          return img.decode().catch(() => {
            return new Promise((resolve) => {
              img.addEventListener("load", resolve, { once: true });
              img.addEventListener("error", resolve, { once: true });
            });
          });
        }

        return new Promise((resolve) => {
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
      }),
    );
  };

  els.forEach((el) => {
    const inner = el.querySelector(innerSelector);
    if (!inner) return;

    if (el.dataset.marqueeInit === "1") return;
    el.dataset.marqueeInit = "1";

    waitImages(el).then(() => {
      const isVertical = el.dataset.marquee === "vertical";
      const getItems = () => Array.from(inner.querySelectorAll(childSelector));

      const measureSetSize = () => {
        const items = getItems();
        let total = 0;

        items.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const style = getComputedStyle(item);

          if (isVertical) {
            const marginT = parseFloat(style.marginTop) || 0;
            const marginB = parseFloat(style.marginBottom) || 0;
            total += rect.height + marginT + marginB;
          } else {
            const marginL = parseFloat(style.marginLeft) || 0;
            const marginR = parseFloat(style.marginRight) || 0;
            total += rect.width + marginL + marginR;
          }
        });

        return total;
      };

      const baseItems = getItems();
      if (!baseItems.length) return;

      let baseSize = measureSetSize();
      if (!baseSize) return;

      const containerSize = isVertical
        ? el.getBoundingClientRect().height
        : el.getBoundingClientRect().width;

      const appendBaseSet = () => {
        const frag = document.createDocumentFragment();
        baseItems.forEach((node) => frag.appendChild(node.cloneNode(true)));
        inner.appendChild(frag);
      };

      while (baseSize < containerSize) {
        appendBaseSet();
        baseSize = measureSetSize();
      }

      const filledSetSize = measureSetSize();
      if (!filledSetSize) return;

      if (tripleAfterFill) {
        const filledNodes = Array.from(inner.children);
        const cloneChildren = () => {
          const frag = document.createDocumentFragment();
          filledNodes.forEach((n) => frag.appendChild(n.cloneNode(true)));
          inner.appendChild(frag);
        };
        cloneChildren();
        cloneChildren();
      }

      const distance = filledSetSize;
      const durationSec = distance / (el.dataset.persec ?? pxPerSec);

      inner.style.setProperty("--marquee-distance", `${distance}px`);
      inner.style.setProperty("--marquee-duration", `${durationSec}s`);
    });
  });
};
